import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const RotateRight = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="RotateRight" {...props}>
    <path d="M21 0.5C21.5523 0.5 22 0.947715 22 1.5V7.37012C21.9999 7.99411 21.4941 8.49994 20.8701 8.5H15C14.4477 8.5 14 8.05228 14 7.5C14 6.94772 14.4477 6.5 15 6.5H19.123C17.476 4.37009 14.8979 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C15.5045 21 18.5432 18.9974 20.0303 16.0693L20.0811 15.9805C20.3549 15.5541 20.9124 15.3958 21.374 15.6299C21.8664 15.8799 22.0635 16.4822 21.8135 16.9746L21.6377 17.3066C19.766 20.699 16.1525 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C15.1534 1 17.9951 2.32802 20 4.45215V1.5C20 0.947715 20.4477 0.5 21 0.5Z" fill="#000" />
  </StyledIcon>
));

RotateRight.displayName = 'RotateRight';

export { RotateRight };
